export default __webpack_public_path__ + "assets/audios/voice.mp3";